<template>
  <div class="pay_result--wrapper layout">
    <div class="pay_result" v-if="isLogin">
      <template v-if="status == 2">
        <img class="pay_icon" src="@/assets/imgs/success@2x.png" />
        <div class="pay_info">
          <div class="pay_msg">下单成功</div>
          <div class="pay_msg_txts">
            <div class="pay_msg_txt">请您保持订单中预留的电话号码畅通</div>
            <div class="pay_msg_txt">客服将尽快与您联系以便确认订单信息</div>
          </div>
          <div class="pay_actions">
            <button class="btn btn--primary" @click="toHome">继续购物</button>
            <button class="btn" @click="toViewOrder">查看详情</button>
          </div>
        </div>
      </template>
      <template v-if="status == 1">
        <img class="pay_icon" src="@/assets/imgs/success@2x.png" />
        <div class="pay_info">
          <div class="pay_msg">支付成功</div>
          <div class="pay_msg_txts">
            <div class="pay_msg_txt">您的订单将在1-3个工作日内发出</div>
            <div class="pay_msg_txt">请关注订单状态并注意签收</div>
          </div>
          <div class="pay_actions">
            <button class="btn btn--primary" @click="toHome">继续购物</button>
            <button class="btn" @click="toViewOrder">查看详情</button>
          </div>
        </div>
      </template>
      <template v-if="status == 0">
        <img class="pay_icon" src="@/assets/imgs/failure@2x.png" />
        <div class="pay_info">
          <div class="pay_msg">支付失败</div>
          <div class="pay_msg_txts">
            <div class="pay_msg_txt">您的订单尚未支付成功</div>
            <div class="pay_msg_txt">请继续支付</div>
          </div>
          <div class="pay_actions">
            <button class="btn btn--primary" @click="toPayOrder">继续支付</button>
            <button class="btn" @click="toViewOrder">查看详情</button>
          </div>
        </div>        
      </template>
    </div>
    <div class="pay_result visitor" v-else>
      <template v-if="status == 1 || status == 2">
        <img class="pay_icon" src="@/assets/imgs/success@2x.png" />
        <div class="pay_info">
          <div class="pay_msg">支付成功</div>
          <div class="pay_msg_txts">
            <div class="pay_msg_txt msg_main">您的订单号： <span class="msg_num">{{sn}}</span> </div>
            <div class="pay_msg_txt">请保管好订单号以便查询使用</div>
          </div>
        </div>
      </template>
      <template v-if="status == 0">
        <img class="pay_icon" src="@/assets/imgs/failure@2x.png" />
        <div class="pay_info">
          <div class="pay_msg">支付失败</div>
          <div class="pay_msg_txts">
            <div class="pay_msg_txt">您的订单未支付成功</div>
          </div>
        </div>        
      </template>

    </div>
    <div class="recommend_wrapper" v-if="status == 1">
      <Recommend region="empty_order_rec" :isTitle="true" />
    </div>
    <!--  -->
    <!-- 扫码付款 -->
    <Dialog :show="dialog == 1" wrapCls="wait_pay" @hide="toClose">
      <div class="payment-header">
        <i class="iconfont payment-icon ali-pay" v-if="paymentMethod == 'AliPay' || paymentMethod == 'HuabeiPay'">&#xe660;</i>
        <i class="iconfont payment-icon wx-pay" v-if="paymentMethod == 'WeixinPay'">&#xe65b;</i>
        <span class="payment-text">{{ paymentMethod | typeify }}支付</span>
      </div>
      <div class="txt-lines" v-if="totalAmount">
        <div class="txt-line">支付金额：<span class="txt-bold">￥{{ totalAmount | toFixed(2) }}</span></div>
        <template v-if="countdown && (countdown.m || countdown.s)">
          <div class="txt-line">距离二维码过期还剩<span class="txt-primary">{{countdown.m}}分{{countdown.s}}秒</span></div>
          <div class="txt-line">过期后请点击刷新重新获取二维码</div>
        </template>
        <template v-else>
          <div class="txt-line">二维码已失效</div>
          <div class="txt-line"><span class="link txt-primary" @click="refreshCode">刷新</span>并获取新二维码</div>
        </template>
      </div>
      <div class="qrcode-wrap" v-if="codeSrc">
        <template v-if="codeMode == 'image'">
          <img class="qrcode-imgage" :src="codeSrc" />
        </template>
        <template v-else-if="codeMode == 'iframe'">
          <iframe class="qrcode-iframe" :src="codeSrc" scrolling="no" align="middle" frameborder="0" seamless />
        </template>
        <div class="qrcode-mask" v-if="codeMask" @click="refreshCode">已失效</div>
      </div>
      <div class="txt-lines">
        <div class="txt-line">打开{{ paymentMethod | typeify }}扫一扫</div>
        <div class="txt-line">扫描上方二维码完成付款</div>
      </div>
    </Dialog>
    <!-- 支付结果 -->
    <Dialog :show="dialog == 2" wrapCls="pay-result" @hide="toClose">
      <div class="txt-lines">
        <div class="txt-line txt-bold">支付结果</div>
        <div class="txt-line mt20">付款完成前请不要关闭窗口，</div>
        <div class="txt-line">完成付款后根据你的情况点击下方按钮！</div>
      </div>
      <button class="btn btn--primary" @click="reCheck">已完成支付</button>
      <button class="btn" @click="toPayOrder">支付遇到问题，重新支付</button>
    </Dialog>
  </div>
</template>

<script>
import Recommend from "@/components/Recommend";
import Dialog from "@/components/Dialog";
import types from "@/store/types";
import api from "@/utils/api";
// import utils from "@/utils";

export default {
  name: "PayResult",
  components: { Recommend, Dialog },
  data() {
    return {
      sn: null,
      status: null,
      paymentChannel: "",
      paymentMethod: "",
      huabeiPeriod: 0,
      totalAmount: 0,
      dialog: 0,
      countdown: { m: 0, s: 0 },
      codeSrc: "",
      codeMode: "image",
      codeMask: false
    }
  },
  created() {
    // 
    let { sn, extras } = this.$route.query;
    if (sn != undefined && extras != undefined) {
      this.sn = sn;
      let parts = String(extras).split("_");
      this.status = parts[0];
      this.paymentChannel = this.toPC(parts[1]);
      this.paymentMethod = this.toPM(parts[2]);
      this.huabeiPeriod = parts[3];
      this.totalAmount = parts[4];
    } else {
      console.warn("缺少必要参数OrderSN");
      // this.$router.back();
      return false;
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  destroyed() {
    this.waitPayTimer && clearInterval(this.waitPayTimer);
    this.wsTimer && clearInterval(this.wsTimer);
    this.wsInstance?.close();
  },
  methods: {
    toPC(paymentChannelIndex) {
      return ["", "NATIVE", "MWEB", "JSAPI"][paymentChannelIndex] || "NATIVE";
    },
    toPM(paymentMethodIndex) {
      return ["Offline", "AliPay", "WeixinPay", "UnionPay", "HuabeiPay"][paymentMethodIndex] || "AliPay";
    },
    toHome() {
      this.$router.replace({ path: "/" });
    },
    toViewOrder() {
      let sn = this.sn;
      this.$router.replace({ path: '/myaccount/orders', query: { sn } });
    },
    // 
    reCheck() {
      this.$router.replace({ path: `/payquery?sn=${this.sn}&cod=${this.status == 2 ? 1 : 0}` });
    },
    // 发起支付
    toPayOrder() {
      if (this.paymentMethod == "Offline") {
        console.info("异常: 货到付款无需支付");
      } else {
        if (this.paymentMethod == "UnionPay") {
          // TODO:: 路径需要注意
          window.open(`/pay?sn=${this.sn}&m=${this.paymentMethod}&t=${this.paymentChannel}`, '_blank');
          this.showPayResult();
        } else  {
          let newArgs = {
            order_sn: this.sn,
            payment_method: this.paymentMethod,
            trade_type: this.paymentChannel,
            again: 1
          };
          if (this.paymentChannel == "JSAPI") {
            newArgs.openid = this.$route.query.openid;
          } else if (this.paymentMethod == 'HuabeiPay') {
            newArgs.hb_fp_num = this.huabeiPeriod;
          }
          api[types.ORDER_PAY](newArgs).then(res => {
            if (res.code == 1) {
              // 二维码方式
              if (this.paymentChannel == "NATIVE" && ["WeixinPay", "AliPay", "HuabeiPay"].indexOf(this.paymentMethod) != -1) {
                this.codeSrc = res.data;
                this.codeMask = false;
                if (["AliPay", "HuabeiPay"].indexOf(this.paymentMethod) != -1) {
                  this.codeMode = "iframe";
                } else {
                  this.codeMode = "image";
                }
                this.waitPayTimer && clearInterval(this.waitPayTimer);
                this.waitPayTimer = this.startCountdown(4* 60, (times, timer) => {
                  if (times > 0) {
                    this.countdown = { m: Math.floor(times/60), s: times % 60 };
                  } else {
                    this.countdown = { m: 0, s: 0 };
                    this.codeMask = true;
                    timer && clearInterval(timer);
                    this.wsTimer && clearInterval(this.wsTimer);
                    this.wsInstance && this.wsInstance?.close();
                  }
                });
                this.showWaitPay();
                this.toQueryOrder();
              } else if (this.paymentChannel == "JSAPI") { // utils.isWXBrowser()
                this.toCallJSAPI(res.data);
              } else { // MWEB or utils.isMobile()
                if (typeof res.data == "object") {
                  location.href = res.data.mweb_url;
                } else {
                  location.href = res.data;
                }
              }
            } else if (res.code != 2) {
              this.$message({ message: res.message, iconCls: "failure" });
            }
          }).catch(err => {
            console.warn(err);
          });
        }
      }
    },
    // 
    toClose() {
      this.dialog = 0;
      this.reCheck();
    },
    // 扫码支付
    showWaitPay() { this.dialog = 1; },
    // 支付结果
    showPayResult() { this.dialog = 2; },
    // 支付成功处理
    showPaySuccess() {
      this.$message({ message: "支付成功", iconCls: "success" });
      this.dialog = 0;
      this.status = 1;
    },
    // 开始制定秒数的倒计时
    startCountdown(times, callback) {
      if (isNaN(times)) return console.warn(`倒计时参数错误: ${times}`), false;
      if (typeof callback != "function") return console.warn("缺少倒计时结束回调函数"), false;
      callback(times);
      let timer = setInterval(() => {
        times--;
        if (times <= 0) {
          timer && clearInterval(timer);
        }
        callback(times, timer);
      }, 1000);
      return timer;
    },
    // 
    toQueryOrder() {
      if (!this.source || !this.source.order_sn) return null;
      let wsInstance = api[types.ORDER_PAY_STATUS_QUERY](this.source.order_sn, (evt, ws) => {
        if (evt?.data) {
          try {
            let res = JSON.parse(evt.data);
            if (res?.code == 1) {
              // this.showPaySuccess();
              this.reCheck();
            } else {
              console.warn(res);
            }
          } catch (err) {
            console.warn(err);
          } finally {
            this.waitPayTimer && clearInterval(this.waitPayTimer);
            this.wsTimer && clearInterval(this.wsTimer);
            wsInstance?.close();
          }
        } else {
          this.waitPayTimer && clearInterval(this.waitPayTimer);
          this.wsTimer && clearInterval(this.wsTimer);
          ws?.close();
        }
      });
      // 每隔30秒发送一次消息确保链接不断
      this.wsTimer = setInterval(() => {
        wsInstance.send(JSON.stringify({ "orderId": this.source.order_sn }));
      }, 30 * 1000);
      this.wsInstance = wsInstance;
      return wsInstance;
    },
    // 检测JSAPI调用环境
    toCallJSAPI(args) {
      if (typeof window.WeixinJSBridge == "undefined"){
        if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', () => this.onBridgeReady(args), false);
        }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', () => this.onBridgeReady(args));
            document.attachEvent('onWeixinJSBridgeReady', () => this.onBridgeReady(args));
        }
      }else{
        this.onBridgeReady(args);
      }
    },
    // JSAPI调用
    onBridgeReady(args) {
      let { appId, timeStamp, nonceStr, signType, paySign } = args;
      if (appId && timeStamp && nonceStr && signType && paySign && args.package) {
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
          "appId": appId,
          "timeStamp": timeStamp,
          "nonceStr": nonceStr,
          "package": args.package,
          "signType": signType,
          "paySign": paySign
        }, function(res){
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if(res.err_msg == "get_brand_wcpay_request:ok" ){
            // this.showPaySuccess();
            this.reCheck();
          } else {
            console.warn('[getBrandWCPayRequest]:: ', res);
            this.$message({ message: res.err_msg, iconCls: "failure" });
          }
        });
      } else {
        this.$message({ message: "网络异常", iconCls: "failure" });
        console.warn(args);
      }
    },
    // 
    refreshCode() {
      this.codeMask = false;
      this.toPayOrder();
    },
  },
  filters: {
    typeify(peymentMethod) {
      let typesMap = { 'AliPay': '支付宝', 'WeixinPay': '微信', 'UnionPay': '银联', 'HuabeiPay': '支付宝', 'Offline': '货到付款' };
      return typesMap[peymentMethod];
    }
  }
}
</script>

<style lang="scss" scoped>
  .pay_result--wrapper {
    padding: 3.75rem 0;
    .pay_result {
      display: flex; flex-direction: column; justify-content: flex-start; align-items: center; margin: 0 auto;
      .pay_icon { width: 97px; height: auto; }
      .pay_info {
        display: flex; flex-direction: column; justify-content: flex-start; align-items: center; width: 100%;
        .pay_msg { font-size: 18px; color: #000; line-height: 25px; font-weight: 700; margin-top: 2rem; }
        .pay_msg_txts {
          margin-top: 10px; text-align: center;
          .pay_msg_txt { font-size: 13px; color: #575757; line-height: 20px; 
            &.msg_main {
              font-size: 24px;
              color: #000;
            }
              .msg_num {
                font-weight: bold;
              }
          }
        }
        .pay_actions {
          margin-top: 30px; width: 100%; padding: 0 40px; display: flex; flex-direction: column;
          .btn {
            display: block; width: 100%;
            &:last-child { margin-top: 1rem; }
          }
        }
      }
      &.visitor {
            border: none;
            flex-direction: column;
            .pay_info {
              align-items: center; margin-left: 0;
              .pay_msg { margin-top: 40px; }
              .pay_msg_txts {
                margin-top: 24px;
                  text-align: center;
                  display: flex;
                  flex-direction: column;
                .pay_msg_txt {
                  text-align: center;
                  padding-bottom: 16px;
                     &.msg_main {
                      font-size: 16px;
                      color: #000;
                    }
                }
              }
              .pay_actions {
                padding: 0; flex-direction: column; align-items: center;
              }
            }
        
      }
    }
    .recommend_wrapper { margin-top: 25px; }
    // 
    ::v-deep .dialog .mask { z-index: 11; }
    // 付款扫码
    ::v-deep .wait_pay .dialog-container {
      width: 470px; height: 570px;
      .dialog-body {
        flex-direction: column; justify-content: flex-start; align-items: center;
        .payment-header {
          display: flex; justify-content: center; align-items: center; margin-top: 56px; width: 100%;
          .payment-icon {
            font-size: 40px;
            &.ali-pay { color: #4F9BF3; }
            &.wx-pay { color: #54A802; }
          }
          .payment-text { font-size: 20px; color: #333333; margin-left: 10px; }
        }
        .txt-lines {
          width: 100%; text-align: center; margin-top: 6px;
          .txt-line { font-size: 14px; color: #666666; }
          .txt-bold { font-size: 25px; color: #C4172E; }
          .txt-primary { font-size: inherit; color: #C4172E; margin: 0 6px; }
        }
        .qrcode-wrap {
          width: 190px; height: 190px; margin: 20px auto; position: relative;
          .qrcode-imgage { width: 100%; }
          .qrcode-iframe { width: 190px; height: 190px; padding: 20px; }
          .qrcode-mask {
            position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); cursor: pointer;
            display: flex; justify-content: center; align-items: center; color: white; font-size: 20px;
          }
        }
      }
    }
    // 付款结果
    ::v-deep .pay-result .dialog-container {
      width: 470px; max-width: 90%; height: 310px;
      .dialog-body {
        flex-direction: column; justify-content: flex-start; align-items: center;
      }
      .txt-lines { width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: center; margin-top: 64px; }
      .txt-line { width: 100%; text-align: center; font-size: 12px; color: #666666; line-height: 24px; }
      .txt-bold, .strong { font-size: 16px; font-weight: 700; color: #333333; }
      .btn { width: 300px; margin-top: 20px; padding: 0.8125rem 0;  }
      .btn-white { background: #FFFFFF; color: #333333; border: 1px solid #C0C0C0; }
    }
  }

  @media screen and (min-width: 48em) {
    .pay_result--wrapper {
      .pay_result {
        padding: 60px; border: 1px solid #DFDFDF; flex-direction: row; max-width: 940px;
        .pay_info {
          align-items: flex-start; margin-left: 45px;
          .pay_msg { margin-top: 0; }
          .pay_msg_txts {
            text-align: left;
            .pay_msg_txt {
              display: inline-block; margin-right: 0.5rem;
            }
          }
          .pay_actions {
            padding: 0; flex-direction: row;
            .btn {
              display: inline-block; width: unset;
              &:last-child { margin-top: 0; margin-left: 30px; }
            }
          }
        }
        
      &.visitor {
            .pay_info {
              .pay_msg_txts {
                .pay_msg_txt {
                     &.msg_main {
                      font-size: 24px;
                      color: #000;
                    }
                }
              }
            }
        }
      }
      .recommend_wrapper {
        max-width: 940px; margin: 0 auto;
        // & /deep/ .recommond-wrap {  }
      }
    }
  }
  @media screen and (min-width: 64em) {}
</style>